import React, { FC } from 'react'
// import { ReactComponent as LogoX } from 'images/logox.svg';
import { FaXTwitter } from 'react-icons/fa6'
import { SocialType } from 'shared/SocialsShare/SocialsShare'

export interface SocialsList1Props {
  className?: string
}

const socials: SocialType[] = [
  {
    name: 'Facebook',
    icon: 'lab la-facebook-square',
    href: 'https://www.facebook.com/ViroTripClube',
  },
  // { name: "Twitter", icon: "lab la-twitter", href: "https://twitter.com/TripViroClube" },
  {
    name: 'Linkedin',
    icon: 'lab la-linkedin',
    href: 'https://www.linkedin.com/company/virotripclube/mycompany/',
  },
  {
    name: 'Instagram',
    icon: 'lab la-instagram',
    href: 'https://www.instagram.com/virotripclube',
  },
]

const SocialsList1: FC<SocialsList1Props> = ({ className = 'space-y-2.5' }) => {
  const renderItem = (item: SocialType, index: number) => {
    return (
      <a
        href={item.href}
        className="flex text-2xl text-neutral-700 hover:text-black dark:text-neutral-300 dark:hover:text-white leading-none space-x-2 group"
        key={index}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className={item.icon}></i>
      </a>
    )
  }

  return (
    <div
      className={`flex justify-start items-center gap-1 nc-SocialsList1 ${className}`}
      data-nc-id="SocialsList1"
    >
      <a
        href="https://twitter.com/TripViroClube"
        className="flex text-2xl text-neutral-700 hover:text-black dark:text-neutral-300 dark:hover:text-white leading-none space-x-2 group"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaXTwitter className="w-5 h-5" />
      </a>
      {socials.map(renderItem)}
    </div>
  )
}

export default SocialsList1
